// features/counterSlice.js
import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    userDetails: {},
    isLoggedIn: false,
  },
  reducers: {
    setLogin: (state, action) => {
      state.userDetails = action.payload;
      state.isLoggedIn = true;
    },
    setLogout: (state, action) => {
      state.userDetails = {};
      state.isLoggedIn = false;
    },
  },
}); 

export const { setLogin, setLogout } = authSlice.actions;
export default authSlice;
